/* eslint-disable */
import { saveAs } from 'file-saver'
import { useIntl } from 'react-intl'
import * as XLSX from 'xlsx'

const formatExcelCellValue = (value) => {
  if (value === null || value === undefined) {
    return ''
  }
  let text = ''
  if (Array.isArray(value)) {
    text = value.filter((item) => item != null).join(' / ')
  } else if (value instanceof Date) {
    text = value.toISOString()
  } else if (typeof value === 'object') {
    text = JSON.stringify(value)
  } else {
    text = String(value)
  }
  return text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '')
}

export const useHandleZip = () => {
  const intl = useIntl()

  const downloadZip = (data, fileName, noIntl) => {
    const getDate = new Date().toLocaleDateString('en-GB').replaceAll('/', '_')

    const rows = Array.isArray(data) ? data : []
    const uniqueKeys = Object.keys(
      rows.reduce(function (res, obj) {
        return Object.assign(res, obj)
      }, {})
    )

    const headers = uniqueKeys.map((item) => {
      const label = noIntl ? item : intl.formatMessage({ id: item })
      return String(label ?? '').replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '')
    })

    const dataRows = rows.map((item) => {
      return uniqueKeys.map((key) => {
        return formatExcelCellValue(item[key])
      })
    })

    const sheetData = [headers, ...dataRows]
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData)
    const colWidths = uniqueKeys.map((key, index) => {
      let maxLen = String(headers[index] || '').length
      for (let i = 0; i < Math.min(dataRows.length, 100); i++) {
        const valLen = String(dataRows[i][index] || '').length
        if (valLen > maxLen) maxLen = valLen
      }
      return { wch: Math.min(Math.max(maxLen + 2, 10), 50) }
    })
    worksheet['!cols'] = colWidths

    const workbook = XLSX.utils.book_new()
    const cleanSheetName = (fileName || 'Report')
      .slice(0, 30)
      .replace(/[:\\?*\[\]\/]/g, '_')
    XLSX.utils.book_append_sheet(workbook, worksheet, cleanSheetName || 'Report')

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      compression: true,
      bookSST: true
    })

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    saveAs(blob, `${fileName}_${getDate}.xlsx`)
  }

  return { downloadZip }
}